module.exports = __webpack_public_path__ + "img/famigliaGlaxiMobile.e9ab7d65.jpg";